import * as React from 'react';

import { DropdownView } from 'src/core/ui/dropdown.view';

interface MarketEditorViewProps {
	marketRequest: DropdownRequest<MarketSummary>;
	value: number | null;
	mode: ControlMode;
	multi?: boolean;
	onChanged: (number: MarketSummary | MarketSummary[]) => void;
	label?: string;
	required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
	afterLoad?: (selectedOptions: any, options: any[]) => void;
	idAgent?: number;
}

export class MarketEditorView extends React.Component<MarketEditorViewProps, any> {
	constructor(props) {
		super(props);
	}

	render() {
		let label = this.props.label;
		if (label === undefined) {
			label = 'Market';
		}

		return (
			<DropdownView
				label={label}
				onGetErrorMessage={this.props.onGetErrorMessage}
				disabled={this.props.mode == 'display'}
				model={this.props.value}
				onChanged={this.props.onChanged}
				request={this.props.marketRequest}
				keyField="id"
				textField="name"
				required={this.props.required}
				afterLoad={this.props.afterLoad}
				cascadeField="idAgent"
				cascadeFiltertype="params"
				cascadeValue={this.props.idAgent}
				multi={this.props.multi}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/market/parts/market-editor.view.tsx